import { pbjs } from '../prebid/index';
import amaLog from '../helpers/log';

let prebidRequestTracked = false;

export const prebidstats = (): any => {
  const errMsg = 'prebidstats Request ad-statistics failed to setup - ';
  let bidRequestListener: Function | undefined;

  if (typeof pbjs !== 'undefined' && pbjs) { 
    try {

      amaLog('prebidstats attachListener');

      bidRequestListener = () => {
  
        amaLog('prebidstats pbjs.onEvent?.(bidRequested) listener called');

        if (prebidRequestTracked) {
          return;
        }
        if (window.ama) {
          window.ama.adStats.add([
            {
              placement: 'prebid',
              gptEvent: 'slotRequested',
            },
          ]);
          window.ama.adStats.push();
        } else {
          window.adStats.add([
            {
              placement: 'prebid',
              gptEvent: 'slotRequested',
            },
          ]);
          window.adStats.push();
        }
        prebidRequestTracked = true;
        removeListener(); 
      };
      const removeListener = () => { 
        amaLog('prebidstats pbjs.offEvent bidRequested - listener removed');        
        pbjs.offEvent?.('bidRequested', bidRequestListener);
      }
      
      pbjs.onEvent?.('bidRequested', bidRequestListener);
    } catch (error) {
      amaLog(`${errMsg} pbjs.onEvent?.( bidRequested, ...) failed ${error}`);      
    }
  } else {
    amaLog(`${errMsg} pbjs is not ready`);
  }
};
